import { NavLink, useRouteError } from 'react-router-dom';
import AppError from './components/AppError';
import { TappLink } from './components/ui/TappLink';

export default function ErrorPage() {
  const error: any = useRouteError();
  console.error(error);

  return (
    <div className="flex items-center justify-center pt-14">
      <div className="w-full max-w-2xl rounded bg-background text-foreground px-4 py-6">
        <p className="mb-4 text-lg font-bold">Sorry, an unexpected error has occurred.</p>
        <AppError error={error} />
        <TappLink className="mt-3 inline-block underline underline-offset-2" to="/">
          Navigate home
        </TappLink>
      </div>
    </div>
  );
}
